/* eslint-disable max-lines */
//TO CHANGE 
import './leftMenu.scss';
import React, { useRef, useState } from 'react';
import SubTituloSeccion from 'components/commons/text/subTituloSeccion/SubTituloSeccion';
import SearchMainResults from './searchMainResults/SearchMainResults';
import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import LeftMenuItem from 'components/features/leftMenuItem/LeftMenuItem';
import { updateMarkers } from 'redux/slices/mapSlice';
import { accentsTidy } from 'utils/utils';
import { ReactComponent as Ic_Search } from 'resources/icons/Ic_search_filled.svg';
import { ReactComponent as Ic_Star } from 'resources/icons/Ic_Star_white.svg';
import { ReactComponent as Ic_News } from 'resources/icons/Ic_News.svg';
import { ReactComponent as Ic_Info } from 'resources/icons/Ic_infoC.svg';
import { ReactComponent as Ic_close } from 'resources/icons/Ic_close.svg';
import { ReactComponent as Ic_Question } from 'resources/icons/Ic_question_fill.svg';
import { ReactComponent as Ic_Route } from 'resources/icons/Ic_Route_Gray.svg';
import { ReactComponent as Ic_Settings } from 'resources/icons/Ic_Hamburguesa_grey.svg';
import { useNavigate } from 'react-router-dom';
import UseSEO from 'hooks/useSEO/UseSEO';
import SearchInput from 'components/commons/inputs/SearchInput/SearchInput';
import { useTranslate } from 'context/languageContext';
import useSearch from 'hooks/useSearch/useSearch';
import { IItemResultSearch } from 'types/interfaces';
import { useDispatch } from 'react-redux';
import { flyTo, updateMarkerSelected, updateMarkerSelectedType } from 'redux/slices/mapSlice';
import {
  MAX_ELEMENTS_SEARCH,
  RUTAS_GENERALES_MUL2,
  SEARCH_LINESSTOPS_TYPES,
  TYPES_MARKERS,
  zoomAcercarseAMarcador,
} from 'utils/constants';
import {
  updateSelectedLine,
  updateSelectedSubLine,
  updateSelectedLineDirection,
  updateSubLines /* , updateSelectedSubLine */,
  updateDirections,
} from 'redux/slices/linesSlice';
import {
  useLazyGetSubLinesQuery,
  useLazyGetSubLineDirectionsQuery,
} from 'redux/services/linesService';
import HomeBannersSecundarios from 'screens/homeScreen/components/homeBannersSecundarios/HomeBannersSecundarios';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { useSelector } from 'react-redux';
import { showEventsState } from 'redux/slices/eventsSlice';

export default function LeftMenu() {
  const scrollMenu = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [generateUrl] = UseSEO();
  const t = useTranslate();
  const [showModaSearch, setShowModalSearch] = useState(false);
  const [filter, setFilter] = useState(0);
  const [showAllStops, setShowAllStops] = useState(false);
  const [showAllPois, setShowAllPois] = useState(false);
  const [showAllLines, setShowAllLines] = useState(false);
  const [showAllNews, setShowAllNews] = useState(false);
  const [showAllfaqs, setShowAllFaqs] = useState(false);
  const [showAllEvents, setShowAllEvents] = useState(false);
  const [GetSubLineDirections] = useLazyGetSubLineDirectionsQuery();
  const [GetSubLines] = useLazyGetSubLinesQuery();
  const bannerSecondary = HomeBannersSecundarios();
  const PREV_MAX_RESULTS = 3;
  const showEvents = useSelector(showEventsState);

  const selectMarker = (itemSelected) => {
    dispatch(updateMarkerSelected(itemSelected.id));
    dispatch(updateMarkerSelectedType(itemSelected.type || TYPES_MARKERS.STOP));
    navigate(generateUrl(RUTAS_GENERALES_MUL2.paradas, itemSelected.type, itemSelected));

    setTimeout(
      () =>
        dispatch(
          flyTo({
            coords: { lat: itemSelected?.position?.lat, lng: itemSelected?.position?.lng },
            zoom: zoomAcercarseAMarcador,
          }),
        ),
      300,
    );
  };

  const STOP_TYPE = 'stop';
  const LINE_TYPE = 'route';
  const [fullScreenOptions, /* setFullScreenOptions */] = useState<Array<any>>([
    //TO CHANGE
    {
      id: 1,
      //text: t('lb_configuracion_account'),
      text: t('lb_configuracion_menu'),
      //icon: Ic_User,
      icon: Ic_Settings,
      onClick: () => navigate(`${generateUrl(RUTAS_GENERALES_MUL2.settings)}?menu-item=language`),
    },
    {
      id: 2,
      text: t('lb_configuracion_menu_favoritos'),
      icon: Ic_Star,
      onClick: () => navigate(generateUrl(RUTAS_GENERALES_MUL2.settingsFavorites)),
    },
    {
      id: 3,
      text: t('lb_buscar'),
      icon: Ic_Search,
      onClick: () => setShowModalSearch(true),
    },
    {
      id: 4,
      text: t('lb_configuracion_menu_avisos'),
      icon: Ic_Info,
      onClick: () => navigate(`${generateUrl(RUTAS_GENERALES_MUL2.notices)}`),
    },
    {
      id: 5,
      text: t('lb_novedades'),
      icon: Ic_News,
      onClick: () => navigate(generateUrl(RUTAS_GENERALES_MUL2.emtNews)),
    },
    {
      id: 6,
      text: t('lb_preguntas_frecuentes'),
      icon: Ic_Question,
      onClick: () => navigate(generateUrl(RUTAS_GENERALES_MUL2.atclientFaq)),
    },
  ]);

  const movilScreenOptions = [
    {
      id: 2,
      text: t('lb_configuracion_menu_favoritos'),
      icon: Ic_Star,
      onClick: () => navigate(generateUrl(RUTAS_GENERALES_MUL2.settingsFavorites)),
    },
    {
      id: 3,
      text: 'Plan',
      icon: Ic_Route,
      onClick: () => navigate(generateUrl(RUTAS_GENERALES_MUL2.planner)),
    },
    {
      id: 4,
      text: t('lb_buscar'),
      icon: Ic_Search,
      onClick: () => setShowModalSearch(true),
    },
    {
      id: 5,
      text: t('lb_configuracion_menu_avisos'),
      icon: Ic_Info,
      onClick: () => navigate(`${generateUrl(RUTAS_GENERALES_MUL2.notices)}`),
    },
    {
      id: 6,
      text: t('lb_configuracion_menu'),
      icon: Ic_Settings,
      onClick: () => navigate(`${generateUrl(RUTAS_GENERALES_MUL2.settings)}`),
    },
  ];

  const handleCloseBtn = () => {
    setShowModalSearch(false);
    clearItemsSearch();
    resetShowAll();
  };
  const handleLineClick = (line) => {
    getLineInfo(line);
  };
  const getLineInfo = async (line, subline: string | undefined = undefined) => {
    dispatch(updateSelectedLine(line));
    dispatch(updateSubLines([]));
    await GetSubLines(line?.id).then(async (result: any) => {
      dispatch(updateSelectedSubLine(null));
      if (result.data) {
        if (result.data.length) {
          await GetSubLineDirections(result.data[0].subLineId).then((res: any) => {
            if (res.data) {
              if (res.data.length) {
                dispatch(updateDirections(res.data));
                const sLine = res.data[0] || {};
                const dir = { ...sLine, subLineId: result.data[0].subLineId };
                dispatch(updateSelectedLineDirection(dir));
                navigate(
                  generateUrl(RUTAS_GENERALES_MUL2.lines, 'LINEA', {
                    linea: line,
                    direccion: { ...dir, subLineId: dir?.subLineId },
                  }),
                );
              }
            }
          });
          dispatch(updateSubLines(result.data));
          dispatch(
            updateSelectedSubLine(
              subline !== undefined
                ? result.data.find((element) => element.subLineId === subline)
                : result.data[0],
            ),
          );
        }
      }
    });
  };

  const clicki = (itemSelected: IItemResultSearch) => {
    dispatch(updateMarkers([]));
    if (itemSelected.type === 'news')
      navigate(
        `${generateUrl(RUTAS_GENERALES_MUL2.emtNewDetail)}${itemSelected.id}/${accentsTidy(
          itemSelected.name,
        )}`,
      );
    else if (itemSelected.type === 'events')
      navigate(
        `${generateUrl(RUTAS_GENERALES_MUL2.eventDetail)}${itemSelected.id}/${accentsTidy(
          itemSelected.name,
        )}`,
      );
    else if (itemSelected.type === 'faqs')
      navigate(
        `${generateUrl(RUTAS_GENERALES_MUL2.atclientFaqCategory)}?faqCategoryId=${
          itemSelected.code
        }&faqId=${itemSelected.id}`,
      );
    else if (itemSelected.type === TYPES_MARKERS.ROUTE) handleLineClick(itemSelected);
    else selectMarker(itemSelected);
    setShowModalSearch(false);
    clearItemsSearch();
  };

  const clickNa = (itemSelected: IItemResultSearch) => {
    navigate(generateUrl(RUTAS_GENERALES_MUL2.planner, 'PLAN', [itemSelected]));
    clearItemsSearch();
    setShowModalSearch(false);
  };

  const [searchAction, itemsSearch, searching, clearItemsSearch] = useSearch(
    clicki,
    clickNa,
    SEARCH_LINESSTOPS_TYPES.both,
    100,
  );

  const resetShowAll = () => {
    setShowAllStops(false);
    setShowAllPois(false);
    setShowAllLines(false);
    setShowAllNews(false);
    setShowAllFaqs(false);
  };

  const handleSearchAction = (value) => {
    if (value) {
      searchAction(value, true);
      resetShowAll();
    } else {
      clearItemsSearch();
    }
  };

  // STOPS
  const ALL_STOPS = itemsSearch?.stopsLines?.filter((item) => item.type === STOP_TYPE);
  const STOPS = showAllStops ? ALL_STOPS : ALL_STOPS.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_STOPS_MSG = `${t('lb_ver_todas_las')} ${ALL_STOPS?.length} ${t(
    'lb_paradas',
  ).toLowerCase()}`;

  // POIS
  const ALL_POIS = itemsSearch?.pois;
  const POIS = showAllPois ? ALL_POIS : ALL_POIS.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_POIS_MSG = `${t('lb_ver_todos_los')} ${ALL_POIS?.length} ${t(
    'lb_explorer_lugares',
  ).toLowerCase()}`;

  // LINES
  const ALL_LINES = itemsSearch.stopsLines.filter((item) => item.type === LINE_TYPE);
  const LINES = showAllLines ? ALL_LINES : ALL_LINES.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_LINES_MSG = `${t('lb_ver_todas_las')} ${ALL_LINES?.length} ${t(
    'lb_lineas',
  ).toLowerCase()}`;

  // NEWS
  const ALL_NEWS = itemsSearch.news;
  const NEWS = showAllNews ? ALL_NEWS : ALL_NEWS.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_NEWS_MSG = `${t('lb_ver_todos_los_resultados')} ${ALL_NEWS?.length} ${t(
    'lb_informacion_consejos_noticias',
  )}`;

  // FAQS
  const ALL_FAQS = itemsSearch.faqs;
  const FAQS = showAllfaqs ? ALL_FAQS : ALL_FAQS.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_FAQS_MSG = `${t('lb_ver_todos_los_resultados')} ${ALL_FAQS?.length} ${t(
    'lb_preguntas_frecuentes',
  ).toLowerCase()}`;
  //Events
  const ALL_EVENTS = itemsSearch.events;
  const eventsSearched = showAllEvents
    ? ALL_EVENTS
    : ALL_EVENTS.filter((el, i) => i < PREV_MAX_RESULTS);
  const ALL_EVENTS_MSG = `${t('lb_ver_todos_los_resultados')} ${ALL_EVENTS?.length} ${t(
    'lb_events',
  ).toLowerCase()}`;

  return (
    <>
      <div className='left-menu-container'>
        {/* MENU IZQUIERDO PANTALLA COMPLETA*/}
        <div className='left-menu' id='left-menu' ref={scrollMenu}>
          {fullScreenOptions.map((item, j) => (
            <LeftMenuItem
              key={`menu-left-${j * 20}-${item.id}`}
              icon={item.icon}
              text={item.text}
              onClick={item.onClick}
            />
          ))}
        </div>

        {/* MENU INFERIOR PANTALLA MOVIL*/}
        <div className='left-menu-movil gradient' id='left-menu-movil' ref={scrollMenu}>
          {movilScreenOptions.map((item, i) => (
            <LeftMenuItem
              key={`menu-left-${i}-${item.id}`}
              icon={item.icon}
              text={item.text}
              onClick={item.onClick}
            />
          ))}
        </div>
      </div>

      {/* MODAL BUSCAR */}
      {showModaSearch && (
        <ModalInfo
          width={searching ? '80%' : 'auto'}
          height='max-content'
          className={'modal-info-left-menu'}
        >
          <div className='close-icon-box-menu' onClick={() => handleCloseBtn()}>
            <SvgIcon Icon={Ic_close} />
          </div>
          <div className='modal-search-top'>
            <SearchInput
              name='search-input-left-menu'
              style={searching && itemsSearch ? { marginLeft: '20px' } : undefined}
              iconLeft={Ic_Search}
              placeholder={t('lb_paradas_lineas_puntos')}
              className='modal-search-input'
              actionOnChange={(value) => handleSearchAction(value)}
            />
            {searching && itemsSearch ? (
              <ul className='modal-search-menu-options'>
                <li className={filter === 0 ? 'tab active' : 'tab'} onClick={() => setFilter(0)}>
                  {t('lb_todo')}
                </li>
                <li className={filter === 1 ? 'tab active' : 'tab'} onClick={() => setFilter(1)}>
                  {t('lb_paradas')}
                </li>
                <li className={filter === 2 ? 'tab active' : 'tab'} onClick={() => setFilter(2)}>
                  {t('lb_lineas')}
                </li>
                <li className={filter === 3 ? 'tab active' : 'tab'} onClick={() => setFilter(3)}>
                  {t('lb_explorer_lugares')}
                </li>
                <li className={filter === 4 ? 'tab active' : 'tab'} onClick={() => setFilter(4)}>
                  {t('lb_noticias')}
                </li>
                <li className={filter === 5 ? 'tab active' : 'tab'} onClick={() => setFilter(5)}>
                  {'Faqs'}
                </li>
                {showEvents ? <li className={filter === 6 ? 'tab active' : 'tab'} onClick={() => setFilter(6)}>
                  {t('lb_events')}
                </li> : null}
              </ul>
            ) : undefined}
          </div>

          {searching && itemsSearch ? (
            <>
              <hr
                style={{ border: '1px solid lightgray', marginTop: '10px', marginRight: '16px' }}
              />
              <div className='modal-search-results'>
                {/* STOPS */}
                {filter === 0 || filter === 1 ? (
                  <>
                    <>
                      <SubTituloSeccion className='modal-search-title' text={t('lb_paradas')} />
                    </>
                    {STOPS?.length > 0 ? (
                      <>
                        <SearchMainResults results={STOPS} />
                        {!showAllStops && ALL_STOPS.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllStops(true)}>
                            <span>{ALL_STOPS_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}

                {/* POIS */}
                {filter === 0 || filter === 3 ? (
                  <>
                    <>
                      <SubTituloSeccion
                        className='modal-search-title'
                        text={t('lb_explorer_lugares')}
                      />
                    </>
                    {POIS?.length > 0 ? (
                      <>
                        <SearchMainResults results={POIS} />
                        {!showAllPois && ALL_POIS.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllPois(true)}>
                            <span>{ALL_POIS_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}

                {/* LINES */}
                {filter === 0 || filter === 2 ? (
                  <>
                    <>
                      <SubTituloSeccion className='modal-search-title' text={t('lb_lineas')} />
                    </>
                    {LINES?.length > 0 ? (
                      <>
                        <SearchMainResults results={LINES} />
                        {!showAllLines && ALL_LINES.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllLines(true)}>
                            <span>{ALL_LINES_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}

                {/* NEWS */}
                {filter === 0 || filter === 4 ? (
                  <>
                    <>
                      <SubTituloSeccion
                        style={{ marginBottom: '16px' }}
                        className='modal-search-title'
                        text={t('lb_noticias')}
                      />
                    </>
                    {NEWS?.length > 0 ? (
                      <>
                        <SearchMainResults results={NEWS} />
                        {!showAllNews && ALL_NEWS.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllNews(true)}>
                            <span>{ALL_NEWS_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}

                {/* FAQS */}
                {filter === 0 || filter === 5 ? (
                  <>
                    <>
                      <SubTituloSeccion
                        style={{ marginBottom: '16px' }}
                        className='modal-search-title'
                        text={t('lb_preguntas_frecuentes')}
                      />
                    </>
                    {FAQS?.length > 0 ? (
                      <>
                        <SearchMainResults results={FAQS} />
                        {!showAllfaqs && ALL_FAQS?.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllFaqs(true)}>
                            <span>{ALL_FAQS_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}
                {/* EVENTOS */}
                {(filter === 0 || filter === 6) && showEvents ? (
                  <>
                    <>
                      <SubTituloSeccion
                        style={{ marginBottom: '16px' }}
                        className='modal-search-title'
                        text={t('lb_events')}
                      />
                    </>
                    {eventsSearched?.length > 0 ? (
                      <>
                        <SearchMainResults results={eventsSearched} />
                        {!showAllEvents && eventsSearched?.length > MAX_ELEMENTS_SEARCH && (
                          <div className='show-all-items' onClick={() => setShowAllEvents(true)}>
                            <span>{ALL_EVENTS_MSG}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='explore_noResults'>{t('lb_No_encontado')}</div>
                    )}
                    <hr style={{ border: '1px solid lightgray', marginTop: '20px' }} />
                  </>
                ) : undefined}

                {
                  <>
                    <>
                      {' '}
                      <div className='modal-search-results-banner'>{bannerSecondary}</div>
                    </>
                  </>
                }
              </div>
            </>
          ) : (
            ''
          )}
        </ModalInfo>
      )}
    </>
  );
}
